<script lang="ts">
  import Announcements from "../components/announcements.svelte";
  import { mainPagePath } from "../support/links";

  export let data;

  $: announcements = data.announcements;
  $: settings = data.settings;
</script>

<main>
  <Announcements {announcements} hero={settings.hero} href={mainPagePath(settings)} />
</main>

<style>
  main {
    background: var(--background-color, #111111);
    flex: 1 1 auto;
    overflow: auto;
    width: 100%;
  }
</style>
